module.exports = __webpack_public_path__ + "assets/h3.2e90a27b.svg";